import { FormProvider } from "react-hook-form";
import { DialogContent } from "@/view/components/ui/dialog";
import useNewPanModal from "./useNewPanModal";
import Header from "./components/Header";
import Steps from "./components/Steps";
import PersonalInfoForm from "./components/PersonalInfoForm";
import AddressForm from "./components/AddressForm";
import BankInfoForm from "./components/BankInfoForm";
import SentProposal from "./components/SentProposal";

export default function NewPanModal() {
  const { steps, title, form, step } = useNewPanModal();

  return (
    <DialogContent
      className={
        step < 3
          ? "flex max-h-[90vh] w-[95vw] max-w-[896px] flex-col"
          : "flex max-h-[90vh] w-[95vw] max-w-[760px] flex-col"
      }
      onInteractOutside={(event) => {
        if (step === 5) {
          event.preventDefault();
        }
      }}
    >
      <div
        className={
          step < 3 ? "flex flex-1 flex-col overflow-y-auto px-2" : "hidden"
        }
      >
        <Header title={title[step]} />
        <Steps visible={step < 3} />
        <form {...form}>
          <FormProvider {...form}>
            <PersonalInfoForm visible={steps.personalInfo} />
            <AddressForm visible={steps.address} />
            <BankInfoForm visible={steps.bankInfo} />
          </FormProvider>
        </form>
      </div>
      <SentProposal visible={steps.sentProposal} />
    </DialogContent>
  );
}
